import React, { useState, useEffect, useRef } from "react";
import "../../../../../../../css/workspace.css";
import { connect, useSelector, useDispatch} from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
    deleteDocumentV2,
  } from "../../../../../../../redux/actions/collectionsV2";
import {
    FileTextOutlined,
    DeleteTwoTone,
  } from "@ant-design/icons";
import { notify } from "../../../../../../../components/Snack";

const ManageDocuments = () => {
    
    const [docsList, setDocsList] = useState([]);

    const dispatch = useDispatch();
    const queryParams = useLocation().search;
    const collectionName =  new URLSearchParams(queryParams).get("name");

    const groupPlan = useSelector((state) => state.userReducer.groupPlan);
    let planType;
    if (groupPlan?.planId == 4) {
        planType = "team";
    } else if (groupPlan?.planId == 5) {
        planType = "business";
    } else {
        planType = "pro";
    }

    const userDetails = useSelector(
        (state) => state?.organizationReducer?.currentOrganization
      );
    const isAdmin = userDetails?.role_id === "2" ? true : false;

    const documentsList = useSelector((state) => state.collectionReducer.collectionDocs);

    useEffect(() => {
      let files = [];
      documentsList?.map((obj, ind) => {
        files?.push({fileName: obj?.document_name, status: obj?.status})
      })
      setDocsList(files);
    },[documentsList]);

    const deleteDoc = async (obj) => {
      const uploadDocumentResponse = await deleteDocumentV2(collectionName, obj?.fileName, planType);

      if (uploadDocumentResponse?.status == "OK") {
          
          const index = docsList.indexOf(obj);
          if (index > -1) {
              setDocsList((prevItems) => [
                  ...prevItems.slice(0, index),  
                  ...prevItems.slice(index + 1)
              ]);
          }
          dispatch(notify("success", "The document has been successfully removed."));
      } else {
          dispatch(notify("error", "Document removal failed."));
      }
    };

    return (
      <div className="wk-manage-docs">
        <ul className="wk-file-list">
          {docsList?.map((obj, index) => (
            <li>
              <div className="wk-file">
                {/* <span className="status warning">in Progress</span> */}
                <span className="status success">{obj?.status}</span>
                <div className="filelist-name">
                  <div className="wk-file-icon">
                    <FileTextOutlined />
                  </div>
                  <p>{obj?.fileName?.length > 18 ? `${obj?.fileName?.substring(18, 0)}...` : obj?.fileName}</p>
                </div>
                {isAdmin ?
                <div className="wk-file-delete"
                  onClick={() => {
                    deleteDoc(obj);
                  }}
                >
                  <DeleteTwoTone twoToneColor="#FF4646" />
                </div> : null}
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
};

export default ManageDocuments;